import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pv-extra-data',
  templateUrl: './extra-data.component.html',
  styleUrls: ['./extra-data.component.scss']
})
export class ExtraDataComponent implements OnInit {
  @Input() hideName: boolean;
  @Input() extraData: {
    name?: string;
    data?: string;
    link?: string;
    route?: string;
  }

  constructor() { }

  ngOnInit() {
  }

}
